import type { ThemeColors } from '../../../../tokens/colors/types';
import { border } from './border';
import { divider } from './divider';
import { blue, green, neutral, orange, pale, purple, red } from './palette';
import { deals, retail } from './product';
import { critical, info, positive, shout, warning } from './semantic';
import { typography } from './typography';

const primary: ThemeColors['primary'] = {
  '10': '#FFF7F3',
  '20': '#FFF0E6',
  '30': '#FFE7D7',
  '50': '#FF6600',
  '70': '#E64E00',
  '80': '#262626',
  '90': '#262626',
};

const secondary: ThemeColors['secondary'] = {
  '20': '#60BEBE',
  '30': '#60BEBE',
  '50': '#60BEBE',
  '70': '#60BEBE',
  '90': '#60BEBE',
};

const baseColors: ThemeColors = {
  blue,
  green,
  red,
  orange,
  primary,
  secondary,
  purple,
  neutral,
  pale,
  info,
  warning,
  critical,
  positive,
  deals,
  retail,
  shout,
  border,
  divider,
  typography,
};

export default baseColors;
